

export const hollyReviewerReviewHinge = {
  _id: 'hollyReviewerReviewHingeId',
  email: 'holly@email.com',
  profileReviewId: 'hollyProfileReviewHingeId',
  reviewerProfileId: 'hollyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Holly! This will really help me!',
  profileReviewedFirstName: 'Frodo',
}

export const luigiReviewerReviewBumble = {
  _id: 'luigiReviewerReviewBumbleId',
  email: 'luigi@email.com',
  profileReviewId: 'luigiProfileReviewBumbleId',
  reviewerProfileId: 'luigiReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Luigi! This will really help me!',
  profileReviewedFirstName: 'Frodo',
}

export const gatsbyReviewerReviewTinder = {
  _id: 'gatsbyReviewerReviewTinderId',
  email: 'gatsby@email.com',
  profileReviewId: 'gatsbyProfileReviewTinderId',
  reviewerProfileId: 'gatsbyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Gatsby! This will really help me!',
  profileReviewedFirstName: 'Frodo',
}